export default __webpack_public_path__ + "static/media/PlantSnippers.fd210fe9.png";